import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/component/selectors/getVariationDraft";
import type { OnsiteUpsellComponent } from "@src/store/slices/experienceBuilder/types";
import {
  openProductPicker,
  setProductPickerProducts,
  setProductPickerSelectedProducts,
  setProductPickerSelectedProductsLoading,
} from "@src/store/slices/productPicker";
import { loadProducts } from "@src/store/slices/productPicker/util/loadProducts";
import { fetchedToSelectedProducts } from "@src/store/slices/productPicker/util/upsellSelection";

// PDP "specific products": open the product picker (product-level) seeded from
// the condition's productIds. The flat rule stores ids only, so fetch each
// product's details so the picker shows them when reopening a saved experience.
export const openOnsiteUpsellPdpProductsProductPicker = createAsyncThunk<
  void,
  { ruleIndex: number; conditionIndex: number }
>(
  "productPicker/openOnsiteUpsellPdpProductsProductPicker",
  async ({ ruleIndex, conditionIndex }, { dispatch, getState }) => {
    dispatch(
      openProductPicker({
        type: "onsiteUpsellPdpProducts",
        ruleIndex,
        conditionIndex,
      })
    );

    const draft = getVariationDraft(getState()) as
      | OnsiteUpsellComponent
      | undefined;
    const condition = draft?.rules[ruleIndex]?.conditions[conditionIndex];
    const productIds =
      condition?.type === "products" ? condition.productIds : [];
    if (productIds.length === 0) {
      dispatch(setProductPickerSelectedProducts([]));
      return;
    }

    dispatch(setProductPickerSelectedProductsLoading(true));
    const { data: products } = await loadProducts({
      first: productIds.length,
      query: productIds.map((id) => `id:${id}`).join(" OR "),
    });
    // Seed the grid so the selected rows render before the live load reconciles.
    dispatch(setProductPickerProducts(products));

    const selectedProducts = fetchedToSelectedProducts(
      products,
      productIds,
      () => ({
        selectedVariantIds: undefined,
        totalVariantCount: undefined,
      })
    );
    dispatch(setProductPickerSelectedProducts(selectedProducts));
    dispatch(setProductPickerSelectedProductsLoading(false));
  }
);
